import React from 'react'
import PropTypes from 'prop-types'
import IconTitle from '../IconTitle'
import './style.sass'

const getClassType = (type = '') => {
  switch (type.toLowerCase()) {
    case 'information' || 'info':
      return 'info'
    case 'info':
      return 'info'
    case 'warning':
      return 'warn'
    case 'warn':
      return 'warn'
    case 'error':
      return 'error'
    default:
      return 'default'
  }
}

const MessageCard = ({ children,type, icon, title, link, message, additionalClass }) => {

  if (!type && !icon && !title && !link && !message) return null
  return (
    <div className={`message-card ${getClassType(type)} ${additionalClass}`}>
      <div className="block-header">
        {(title || icon) && <IconTitle icon={icon} title={title} />}
        {!link || <a href={link}>{link}</a>}
      </div>
      {!message || (
        <p>{message}</p>
      )}
     {!children || children}
    </div>
  )
}

MessageCard.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  link: PropTypes.string,
  message: PropTypes.string
}

export default MessageCard

